import React, { Component } from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import { AdminPublicRoute, AdminRoute } from "./AdminRoute";

import AdminLogin from "../Pages/Admin/AdminLogin/AdminLogin";
import Dashboard from "../Pages/Admin/Dashboard/Dashboard";
import ViewStudent from "../Pages/Admin/Students/ViewStudents/ViewStudent";
import AddStudent from "../Pages/Admin/Students/AddStudent/AddStudent";
import EditStudent from "../Pages/Admin/Students/EditStudent/EditStudent";
import StudentDetail from "../Pages/Admin/Students/StudentDetail/StudentDetail";
import ViewStaff from "../Pages/Admin/StaffInfo/ViewStaff/ViewStaff";
import AddStaff from "../Pages/Admin/StaffInfo/AddStaff/AddStaff";
import EditStaff from "../Pages/Admin/StaffInfo/EditStaff/EditStaff";
import StaffDetail from "../Pages/Admin/StaffInfo/StaffDetail/StaffDetail";
import AddNotice from "../Pages/Admin/Notice/AddNotice/AddNotice";
import ViewNotice from "../Pages/Admin/Notice/ViewNotice/ViewNotice";

import AddExam from "../Pages/Admin/Examination/ExamType/AddExam/AddExam";
import MarksRegister from "../Pages/Admin/Examination/MarksRegister/MarksRegister";
import ViewPublishMarks from "../Pages/Admin/Examination/PublishResults/ViewPublishMarks/ViewPublishMarks";

import AddVehicle from "../Pages/Admin/Transportation/Vehicle/AddVehicle/AddVehicle";
import EditVehicle from "../Pages/Admin/Transportation/Vehicle/EditVehicle/EditVehicle";
import VehicleDetails from "../Pages/Admin/Transportation/Vehicle/VehicleDetails/VehicleDetails";
import ViewVehicle from "../Pages/Admin/Transportation/Vehicle/ViewVehicle/ViewVehicle";

import ViewClass from "../Pages/Admin/SchoolClass/ViewClass/ViewClass";
import AddClass from "../Pages/Admin/SchoolClass/AddClass/AddClass";
import EditClass from "../Pages/Admin/SchoolClass/EditClass/EditClass";
import ClassDetail from "../Pages/Admin/SchoolClass/ClassDetail/ClassDetail";

import ViewSubject from "../Pages/Admin/SchoolSubjects/ViewSubject/ViewSubject";

import ViewGrade from "../Pages/Admin/Grade/ViewGrade/ViewGrade";
import AddGrade from "../Pages/Admin/Grade/AddGrade/AddGrade";

import ViewExam from "../Pages/Admin/Examination/ExamType/ViewExam/ViewExam";
import ViewExamConfig from "../Pages/Admin/Examination/ExamConfig/ViewExamConfig/ViewExamConfig";
import AddExamConfig from "../Pages/Admin/Examination/ExamConfig/AddExamConfig/AddExamConfig";
import EditExamConfig from "../Pages/Admin/Examination/ExamConfig/EditExamConfig/EditExamConfig";
import ExamConfigDetails from "../Pages/Admin/Examination/ExamConfig/ExamConfigDetails/ExamConfigDetails";

import ViewFeeType from "../Pages/Admin/Fees/FeeTypes/ViewFeeType/ViewFeeType";

import ViewDriver from "../Pages/Admin/Transportation/TransportDriver/ViewDriver/ViewDriver";
import AddDriver from "../Pages/Admin/Transportation/TransportDriver/AddDriver/AddDriver";
import EditDriver from "../Pages/Admin/Transportation/TransportDriver/EditDriver/EditDriver";
import DriverDetails from "../Pages/Admin/Transportation/TransportDriver/DriverDetails/DriverDetails";
import ManageVehicleStudent from "../Pages/Admin/Transportation/ManageVehicleStudent/ManageVehicleStudent";

import ViewRole from "../Pages/Admin/Role/ViewRole/ViewRole";

import ViewInventory from "../Pages/Admin/Inventory/ViewInventory/ViewInventory";
import InventoryDetails from "../Pages/Admin/Inventory/InventoryDetails/InventoryDetails";
import ViewItems from "../Pages/Admin/Inventory/AddInventory/ViewItems/ViewItems";

import OverallTimetable from "../Pages/Admin/TimeTable/OverallTimetable/OverallTimetable";
import TimeTable from "../Pages/Admin/TimeTable/ManageTimetable/TimeTable";
import TeacherTimeTable from "../Pages/Admin/TimeTable/TeacherTimeTable/TeacherTimeTable";

import ViewBookList from "../Pages/Admin/Library/BookList/ViewBookList/ViewBookList";
import AddBookList from "../Pages/Admin/Library/BookList/AddBookList/AddBookList";
import BookDetails from "../Pages/Admin/Library/BookList/BookDetails/BookDetails";

import ViewFeeGroup from "../Pages/Admin/Fees/FeeGroup/ViewFeeGroup/ViewFeeGroup";
import FeeGroupDetails from "../Pages/Admin/Fees/FeeGroup/FeeGroupDetails/FeeGroupDetails";
import ManageFee from "../Pages/Admin/Fees/ManageFee/ManageFee";

import StudentAttendance from "../Pages/Admin/Attendance/StudentAttendance/StudentAttendance";
import ViewStaffAttendance from "../Pages/Admin/Attendance/StaffAttendance/ViewStaffAttendance/ViewStaffAttendance";

import GeneralSetting from "../Pages/Admin/Setting/GeneralSetting";

import ViewAcademics from "../Pages/Admin/Academics/ViewAcademics/ViewAcademics";

import ViewAssignment from "../Pages/Admin/Assignment/ViewAssignment/ViewAssignment";
import AddAssignment from "../Pages/Admin/Assignment/AddAssignment/AddAssignment";
import AssignmentDetails from "../Pages/Admin/Assignment/AssignmentDetails/AssignmentDetails";
import AcademicsDetails from "../Pages/Admin/Academics/AcademicsDetails/AcademicsDetails";

import UserDashboard from "../Pages/User/UserDashboard/UserDashboard";
import { UserPublicRoute, UserRoute } from "./UserRoute";
import UserLogin from "../Pages/User/UserLogin/UserLogin";
import UserNotice from "../Pages/User/UserNotice/UserNotice";
import UserFees from "../Pages/User/UserFees/UserFees";
import UserSyllabus from "../Pages/User/UserSyllabus/UserSyllabus";
import UserAssignments from "../Pages/User/UserAssignments/UserAssignments";
import UserAttendance from "../Pages/User/UserAttendance/UserAttendance";
import UserExamination from "../Pages/User/UserExamination/UserExamination";
import UserLibrary from "../Pages/User/UserLibrary/UserLibrary";
import UserTimetable from "../Pages/User/UserTimetable/UserTimetable";
import UserProfile from "../Pages/User/UserProfile/UserProfile";
import UserResults from "../Pages/User/UserResults/UserResults";
import UserAbout from "../Pages/User/UserAbout/UserAbout";
import TeacherAssignmentDetails from "../Pages/User/UserAssignments/Assignment/TeacherAssignmentDetails/TeacherAssignmentDetails";
import PromoteStudents from "../Pages/Admin/PromoteStudents/PromoteStudents";

class Routes extends Component {
  render() {
    return (
      <Switch>
        <AdminPublicRoute
          path="/administration"
          isAdmin={this.props.isAdmin}
          restricted={true}
          exact
          component={AdminLogin}
        />

        <AdminRoute
          path="/administration/dashboard"
          isAdmin={this.props.isAdmin}
          exact
          component={Dashboard}
        />

        <AdminRoute
          path="/administration/user"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewRole}
        />

        <AdminRoute
          path="/administration/class"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewClass}
        />
        <AdminRoute
          path="/administration/class/add"
          isAdmin={this.props.isAdmin}
          exact
          component={AddClass}
        />
        <AdminRoute
          path="/administration/class/edit/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={EditClass}
        />
        <AdminRoute
          path="/administration/class/detail/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={ClassDetail}
        />

        <AdminRoute
          path="/administration/subject"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewSubject}
        />

        <AdminRoute
          path="/administration/grade"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewGrade}
        />
        <AdminRoute
          path="/administration/grade/add"
          isAdmin={this.props.isAdmin}
          exact
          component={AddGrade}
        />

        <AdminRoute
          path="/administration/students"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewStudent}
        />
        <AdminRoute
          path="/administration/students/add"
          isAdmin={this.props.isAdmin}
          exact
          component={AddStudent}
        />
        <AdminRoute
          path="/administration/students/edit/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={EditStudent}
        />
        <AdminRoute
          path="/administration/students/detail/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={StudentDetail}
        />
        <AdminRoute
          path="/administration/students-Promote"
          isAdmin={this.props.isAdmin}
          exact
          component={PromoteStudents}
        />

        <AdminRoute
          path="/administration/Fees-Type"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewFeeType}
        />
        <AdminRoute
          path="/administration/Fees-Group"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewFeeGroup}
        />
        <AdminRoute
          path="/administration/Fees-Group/details/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={FeeGroupDetails}
        />
        <AdminRoute
          path="/administration/Fees-Manage"
          isAdmin={this.props.isAdmin}
          exact
          component={ManageFee}
        />

        <AdminRoute
          path="/administration/driver/add"
          isAdmin={this.props.isAdmin}
          exact
          component={AddDriver}
        />
        <AdminRoute
          path="/administration/driver"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewDriver}
        />
        <AdminRoute
          path="/administration/driver/edit/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={EditDriver}
        />
        <AdminRoute
          path="/administration/driver/details/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={DriverDetails}
        />

        <AdminRoute
          path="/administration/vehicle"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewVehicle}
        />
        <AdminRoute
          path="/administration/vehicle/add"
          isAdmin={this.props.isAdmin}
          exact
          component={AddVehicle}
        />
        <AdminRoute
          path="/administration/vehicle/edit/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={EditVehicle}
        />
        <AdminRoute
          path="/administration/vehicle/details/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={VehicleDetails}
        />
        <AdminRoute
          path="/administration/vehicle/manage"
          isAdmin={this.props.isAdmin}
          exact
          component={ManageVehicleStudent}
        />

        <AdminRoute
          path="/administration/staffs"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewStaff}
        />
        <AdminRoute
          path="/administration/staffs/add"
          isAdmin={this.props.isAdmin}
          exact
          component={AddStaff}
        />
        <AdminRoute
          path="/administration/staffs/edit/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={EditStaff}
        />
        <AdminRoute
          path="/administration/staffs/detail/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={StaffDetail}
        />

        <AdminRoute
          path="/administration/inventory"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewInventory}
        />
        <AdminRoute
          path="/administration/inventory/add"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewItems}
        />
        <AdminRoute
          path="/administration/inventory/details/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={InventoryDetails}
        />

        <AdminRoute
          path="/administration/notices/add"
          isAdmin={this.props.isAdmin}
          exact
          component={AddNotice}
        />
        <AdminRoute
          path="/administration/notices"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewNotice}
        />

        <AdminRoute
          path="/administration/exam"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewExam}
        />
        <AdminRoute
          path="/administration/exam/add"
          isAdmin={this.props.isAdmin}
          exact
          component={AddExam}
        />
        <AdminRoute
          path="/administration/examconfig"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewExamConfig}
        />
        <AdminRoute
          path="/administration/examconfig/add"
          isAdmin={this.props.isAdmin}
          exact
          component={AddExamConfig}
        />
        <AdminRoute
          path="/administration/examconfig/edit/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={EditExamConfig}
        />
        <AdminRoute
          path="/administration/examconfig/detail/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={ExamConfigDetails}
        />

        <AdminRoute
          path="/administration/Marks-Register"
          isAdmin={this.props.isAdmin}
          exact
          component={MarksRegister}
        />

        <AdminRoute
          path="/administration/Marks-Publish"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewPublishMarks}
        />

        <AdminRoute
          path="/administration/timetable"
          isAdmin={this.props.isAdmin}
          exact
          component={TimeTable}
        />
        <AdminRoute
          path="/administration/timetable/overall"
          isAdmin={this.props.isAdmin}
          exact
          component={OverallTimetable}
        />
        <AdminRoute
          path="/administration/timetable/teacher"
          isAdmin={this.props.isAdmin}
          exact
          component={TeacherTimeTable}
        />

        <AdminRoute
          path="/administration/library"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewBookList}
        />
        <AdminRoute
          path="/administration/library/add"
          isAdmin={this.props.isAdmin}
          exact
          component={AddBookList}
        />
        <AdminRoute
          path="/administration/library/details/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={BookDetails}
        />

        <AdminRoute
          path="/administration/Student-Attendance"
          isAdmin={this.props.isAdmin}
          exact
          component={StudentAttendance}
        />

        <AdminRoute
          path="/administration/Staff-Attendance"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewStaffAttendance}
        />

        <AdminRoute
          path="/administration/settings"
          isAdmin={this.props.isAdmin}
          exact
          component={GeneralSetting}
        />

        <AdminRoute
          path="/administration/academics"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewAcademics}
        />
        <AdminRoute
          path="/administration/academics/details/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={AcademicsDetails}
        />

        <AdminRoute
          path="/administration/assignment"
          isAdmin={this.props.isAdmin}
          exact
          component={ViewAssignment}
        />
        <AdminRoute
          path="/administration/assignment/add"
          isAdmin={this.props.isAdmin}
          exact
          component={AddAssignment}
        />
        <AdminRoute
          path="/administration/assignment/details/:id"
          isAdmin={this.props.isAdmin}
          exact
          component={AssignmentDetails}
        />

        <UserPublicRoute
          path="/"
          restricted={true}
          isUser={this.props.isUser}
          exact
          component={UserLogin}
        />

        <UserRoute
          path="/dashboard"
          isUser={this.props.isUser}
          exact
          component={UserDashboard}
        />

        <UserRoute
          path="/notices"
          isUser={this.props.isUser}
          exact
          component={UserNotice}
        />

        <UserRoute
          path="/fees"
          isUser={this.props.isUser}
          exact
          component={UserFees}
        />

        <UserRoute
          path="/syllabus"
          isUser={this.props.isUser}
          exact
          component={UserSyllabus}
        />

        <UserRoute
          path="/timetable"
          isUser={this.props.isUser}
          exact
          component={UserTimetable}
        />

        <UserRoute
          path="/library"
          isUser={this.props.isUser}
          exact
          component={UserLibrary}
        />

        <UserRoute
          path="/examination"
          isUser={this.props.isUser}
          exact
          component={UserExamination}
        />

        <UserRoute
          path="/result"
          isUser={this.props.isUser}
          exact
          component={UserResults}
        />

        <UserRoute
          path="/attendance"
          isUser={this.props.isUser}
          exact
          component={UserAttendance}
        />

        <UserRoute
          path="/assignments"
          isUser={this.props.isUser}
          exact
          component={UserAssignments}
        />
        <UserRoute
          path="/assignments/details/:id"
          isUser={this.props.isUser}
          exact
          component={TeacherAssignmentDetails}
        />

        <UserRoute
          path="/profile"
          isUser={this.props.isUser}
          exact
          component={UserProfile}
        />

        <UserRoute
          path="/about"
          isUser={this.props.isUser}
          exact
          component={UserAbout}
        />
      </Switch>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAdmin: state.AdminReducer.isAdmin,
    isUser: state.UserReducer.isUser,
  };
};

export default connect(mapStateToProps, null)(Routes);
